import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { toggleShareDialog } from '../share-room/actions';
import { setOverflowMenuVisible } from '../toolbox/actions.web';
import { BEGIN_ADD_PEOPLE, HIDE_ADD_PEOPLE_DIALOG } from './actionTypes';
import './middleware.any';
/**
 * The middleware of the feature invite specific to Web/React.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case BEGIN_ADD_PEOPLE:
            return _beginAddPeople(store, next, action);
        case HIDE_ADD_PEOPLE_DIALOG:
            return _hideAddPeopleDialog(store, next, action);
    }
    return next(action);
});
/**
 * Opens the ShareMeetingPopup instead of the AddPeopleDialog.
 * Also closes the overflow menu (bottom sheet) if it's open on mobile.
 *
 * @param {Store} store - The redux store.
 * @param {Dispatch} next - The redux dispatch function.
 * @param {Action} action - The redux action.
 * @private
 * @returns {*} The value returned by {@code next(action)}.
 */
function _beginAddPeople({ dispatch }, next, action) {
    const result = next(action);
    // Close overflow menu if open (especially on mobile)
    dispatch(setOverflowMenuVisible(false));
    // Open share meeting dialog
    dispatch(toggleShareDialog(true));
    return result;
}
/**
 * Hides the ShareMeetingPopup.
 *
 * @param {Store} store - The redux store.
 * @param {Dispatch} next - The redux dispatch function.
 * @param {Action} action - The redux action.
 * @private
 * @returns {*} The value returned by {@code next(action)}.
 */
function _hideAddPeopleDialog({ dispatch }, next, action) {
    dispatch(toggleShareDialog(false));
    return next(action);
}
